import React from 'react';

/**
 * Official MyLeaf Legacy logo (transparent SVG).
 *
 * Two tone variants for full light/dark adaptability — no wrapper tiles:
 *   - `tone="green"` (default) → brand mark as-is (dark green + gold on cream/white surfaces).
 *   - `tone="cream"` → cream-inked variant for deep-green / dark surfaces.
 *
 * Both variants are transparent SVG files served from `/brand/`.
 */
const LOGO_GREEN = '/brand/myleaf-logo.svg';
const LOGO_CREAM = '/brand/myleaf-logo-cream.svg';

export function Logo({ size = 40, className = '', tone = 'green' }) {
  const src = tone === 'cream' ? LOGO_CREAM : LOGO_GREEN;
  return (
    <div className={`inline-flex items-center ${className}`} data-testid="myleaf-logo">
      <img
        src={src}
        alt="MyLeaf Legacy"
        width={size}
        height={size}
        style={{
          width: `${size}px`,
          height: `${size}px`,
          objectFit: 'contain',
          flexShrink: 0,
          display: 'block',
        }}
      />
    </div>
  );
}
